module.exports = __webpack_public_path__ + "media/images/shared/icon_anchor_arrow-36103235541b40d1478dc90409366761.svg";